import { SearchResultsItem } from '@models';
import { BaseComponent } from '../base.component';
import { SearchResultsItemComponent } from '../search-results-item/search-results-item.component';
import defaultHtml from './search-results-list.component.hbs';

export class SearchResultsListComponent extends BaseComponent<Array<SearchResultsItem>> {
    protected override bindEvent = 'hawksearch:bind-search-results-list';
    protected override customTemplatePropertyName = 'searchResultsList';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.length) {
            return '';
        }

        const html = template({
            items: this.data
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll<SearchResultsItemComponent>('hawksearch-results-item').forEach((component, index) => {
            component.data = this.data?.[index];
        });
    }
}
